/**
 * Copyright (c) ProductiveHub, Inc. All Rights Reserved.
 *
 *
 * @summary
 * @author Andrew McCrink <andrew@emagid.com.com>
 *
 * Created: 01/12/2022
 */
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router";

export const IdleTimeoutContext = React.createContext<
  | {
      showHomepageScreensaver: boolean;
    }
  | undefined
>(undefined);

export const IdleTimeoutProvider = ({ children }: any) => {
  const navigate = useNavigate();
  const [timeoutTime, setTimeoutTime] = useState(
    process.env.REACT_APP_ENVIRONMENT === "local" ? 99999999 : 120000
  );
  const [homepageScreensaverTime, setHomepageScreensaverTime] = useState(
    process.env.REACT_APP_ENVIRONMENT === "local" ? 99999999 : 120000
  );
  const [showHomepageScreensaver, setShowHomepageScreensaver] =
    useState<boolean>(false);
  let timeout: any = false;
  let homepageScreensaverTimeout: any = false;

  useEffect(() => {
    const events = [
      "load",
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress",
    ];

    const resetTimeout = () => {
      clearTimeouts();
      setTimeouts();
    };

    for (let i in events) {
      window.addEventListener(events[i], resetTimeout);
    }

    setTimeouts();
    return () => {
      for (let i in events) {
        window.removeEventListener(events[i], resetTimeout);
        clearTimeouts();
      }
    };
  }, []);

  const setTimeouts = () => {
    timeout = setTimeout(goHome, timeoutTime);
    homepageScreensaverTimeout = setTimeout(
      activateScreensaver,
      homepageScreensaverTime
    );
  };

  const clearTimeouts = () => {
    if (timeout) clearTimeout(timeout);
    if (homepageScreensaverTimeout) clearTimeout(homepageScreensaverTimeout);
    setTimeout(() => {
      setShowHomepageScreensaver(false);
    }, 200);
  };

  const goHome = () => {
    navigate("/");
  };

  const activateScreensaver = () => {
    setShowHomepageScreensaver(true);
  };

  return (
    <IdleTimeoutContext.Provider value={{ showHomepageScreensaver }}>
      {children}
    </IdleTimeoutContext.Provider>
  );
};

export const useIdleTimer = () => useContext(IdleTimeoutContext);
